import { render, staticRenderFns } from "./Chassis.vue?vue&type=template&id=63b7a871"
import script from "./Chassis.vue?vue&type=script&lang=js"
export * from "./Chassis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports